<template>
    <v-card flat>
            <v-card-text>

                <v-snackbar top v-model="success" color="success">
                    <span> <v-icon>check_circle</v-icon> {{messages}} </span>
                </v-snackbar>

                <v-snackbar top v-model="error" color="error">
                    <span> <v-icon>info</v-icon> {{messages}} </span>
                </v-snackbar>

                <h3>Editar media</h3>
                    <v-container fluid grid-list-lg>
                        <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row wrap>

                            <v-flex xl6 lg6 md6   sm12 xs12>
                                <v-text-field
                                        v-model="register.name"
                                        :rules="nameRules"
                                        label="Título"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xl6 lg6 md6 sm12 xs12>
                                <v-text-field
                                        v-model="register.bpm"
                                        :rules="nameRules"
                                        label="BPM"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xl6 lg6 md6 sm12 xs12>
                                <v-text-field
                                        v-model="register.keyword"
                                        :rules="nameRules"
                                        label="Key"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xl6 lg6 md6 sm12 xs12>
                                <v-select
                                        required
                                        v-model="register.category_id"
                                        :items="categories"
                                        item-value="id"
                                        item-text="name"
                                        label="Categoria"
                                ></v-select>
                            </v-flex>

                            <v-flex xl6 lg6 md6 sm12 xs12>
                                <v-select
                                        required
                                        v-model="register.subcategory_id"
                                        item-value="id"
                                        item-text="name"
                                        :items="subcategories"
                                        label="Subcategoria"
                                ></v-select>
                            </v-flex>

                            <v-flex xl6 lg6 md6 sm12 xs12>
                                <v-select
                                        flat
                                        solo
                                        v-model="register.tags"
                                        :items="tags"
                                        item-text="tag"
                                        chips
                                        placeholder="Clique aqui para associar tags"
                                        multiple
                                        return-object
                                ></v-select>
                            </v-flex>

                            <v-flex xl12 lg12 md12 sm12 xs12>
                                <v-btn flat class="primary" @click="update">Atualizar</v-btn>
                                <v-btn flat class="secondary" @click="clear">Cancelar</v-btn>
                            </v-flex>

                        </v-layout>
                        </v-form>
                    </v-container>
            </v-card-text>
        </v-card>
</template>

<script>
    export default {
        name: 'medias-edit',
        props:['register'],
        data: () => ({
            register: JSON.parse(localStorage.getItem('register')),
            categories:[],
            subcategories:[],
            valid: true,
            error: false,
            success: false,
            messages: '',
            nameRules: [
                v => !!v || 'Campo obrigatório',
            ],
            tags: []
        }),
        methods: {
            update() {
                var self = this
                self.error = false
                self.messages = ''
                if (self.$refs.form.validate()) {
                    self.$store.commit('setLoading', true)
                    self.axios.post('/edit-medias.json', self.register, {
                        headers: {
                            'Authorization': self.$store.state.token
                        }
                    }).then(function (response) {
                        self.$store.commit('setLoading', false)
                        if (response.data.success === true) {
                            self.messages = response.data.messages
                            self.success = true
                            setTimeout(function () {
                                self.$router.push('/')
                            }, 2000)
                        } else {
                            self.error = true
                            self.messages = response.data.messages
                        }
                    })
                }
            },
            clear() {
                this.$router.push('/')
            },
            getCategoriesFromApi() {
                var self = this
                self.axios.get('/get-categories.json',{
                    headers: {
                        'Authorization': self.$store.state.token
                    }
                }).then((response) => {
                    self.categories = response.data
                })
            },
            getSubCategoriesFromApi() {
                var self = this
                self.axios.get('/get-subcategories.json',{
                    headers: {
                        'Authorization': self.$store.state.token
                    }
                }).then((response) => {
                    self.subcategories = response.data
                })
            },
            getTagsFromApi() {
                var self = this
                self.axios.get('/get-tags.json',{
                    headers: {
                        'Authorization': self.$store.state.token
                    }
                }).then((response) => {
                    self.tags = response.data
                })
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.getCategoriesFromApi()
                this.getSubCategoriesFromApi()
                this.getTagsFromApi()
                this.register = JSON.parse(localStorage.getItem("register"))
            })
        }
    }
</script>
